import { Link } from 'react-router-dom'
import Error from 'assets/img/404.png'
import { KoaConsumer } from '@app/utils/KoaContext'

const NotFound = () => {
    return (
        <KoaConsumer>
            {context => {
                if (context) {
                    context.status = 404
                }
                return (
                    <div className="flex flex-col items-center justify-center">
                        <img className="w-[719px] mx-[auto]" src={Error} alt="404" />
                        <h1 className="text-[16px] text-center text-primaryText">
                            Sorry, the page you requested does not exist
                        </h1>
                        <div className="text-[14px] line-[14px] text-center mt-[12px]">
                            <Link className="text-brand" reloadDocument to="/">
                                <span>Return to homepage</span>
                                {` >`}
                            </Link>
                        </div>
                    </div>
                )
            }}
        </KoaConsumer>
    )
}

export default NotFound
